import { Injectable } from '@angular/core';
import {
  CanLoad,
  Route,
  UrlSegment,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { RolesPermissionsService } from './roles-permissions.service';
import { PermissionAction } from '@app/interfaces';

@Injectable({
  providedIn: 'root',
})
export class RolesPermissionGuard implements CanLoad, CanActivate {
  constructor(private rolesPermissionsService: RolesPermissionsService, private router: Router) {}

  private checkPermissions(permissionsKeys?: Array<{ module: string; key?: PermissionAction }>): boolean {
    if (this.rolesPermissionsService.getIsAdmin()) return true;

    if (!permissionsKeys?.length) return true;

    const allowed = permissionsKeys.some((p) =>
      p.key ? this.rolesPermissionsService.can(p.module, p.key) : this.rolesPermissionsService.canRead(p.module)
    );

    if (!allowed) {
      this.router.navigate(['/401']);
      return false;
    }

    return true;
  }

  canLoad(route: Route, segments: UrlSegment[]): boolean {
    const permissionsKeys = route.data?.['permissionsKeys'] as Array<{ module: string; key?: PermissionAction }>;
    return this.checkPermissions(permissionsKeys);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const permissionsKeys = route.data?.['permissionsKeys'] as Array<{ module: string; key?: PermissionAction }>;
    return this.checkPermissions(permissionsKeys);
  }
}
